import styled from "styled-components";

const CountryFlagDiv = styled.div`
  font-size: ${({ $fs }) => `${$fs}px`};
`;

// Regional indicator letters: "DE" -> 🇩🇪
// Converts a two-letter ISO country code into its corresponding flag emoji.
export const flagFromIsoCode = (isoCode) =>
  [...isoCode]
    .map((letter) => String.fromCodePoint(127397 + letter.charCodeAt(0)))
    .join("");

const CountryFlagEmoji = ({ fs = "20", isoCode }) => {
  return <CountryFlagDiv $fs={fs}>{flagFromIsoCode(isoCode)}</CountryFlagDiv>;
};
export default CountryFlagEmoji;
